export const SET_UNSELECT_EMPLOYEE = "SET_UNSELECT_EMPLOYEE";
export const REMOVE_UNSELECT_EMPLOYEE = "REMOVE_UNSELECT_EMPLOYEE";
export const REST_UNSELECT_EMPLOYEE = "REST_UNSELECT_EMPLOYEE";
